export * from './add-department-group';
export * from './assign-department';

import { AddDepartmentGroupComponent } from './add-department-group';
import { AssignDepartmentToDepartmentGroupsComponent } from './assign-department';

export const DepartmentGroupOrganisms = [
    AddDepartmentGroupComponent,
    AssignDepartmentToDepartmentGroupsComponent
]